<script>
  import { mapGetters } from 'vuex'
  import ListView from '../base/ListView.vue'
  import FilterLookupSelect from '../base/FilterLookupSelect.vue'

  export default {
    components: {
      ListView,
      FilterLookupSelect,
    },
    computed: {
      ...mapGetters({
        customer: 'project/list/references/customer/item',
      }),
    },
    methods: {
      deleteRow(item) {
        this.del(item).then(() => this.getPage())
      },
    }
  }
</script>
<template>
  <list-view store="project" add-route="ProjectCreate" edit-route="ProjectUpdate">
    <template v-slot:filter="">
      <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
        <b-input-group>
          <filter-lookup-select
            store="project/list/lookup/customer"
            :placeholder="$t('project.filter-header.customer-placeholder')"
            :search-placeholder="$t('project.filter-header.customer-search-placeholder')"
          >
            <template v-slot:selected-item="slotProps">
              {{slotProps.item.addr1}}
              {{slotProps.item.addr2}}
            </template>
            <template v-slot:item="slotProps">
              {{slotProps.item.addr1}}<br/>
              {{slotProps.item.addr2}}
            </template>
          </filter-lookup-select>
        </b-input-group>
      </b-form-group>
    </template>

    <template v-slot:header="slotProps">
      <b-col md="2"><strong>{{ $t('project.projectnr.label') }}</strong></b-col>
      <b-col md="4"><strong>{{ $t('project.name.label') }}</strong></b-col>
      <b-col md="4"><strong>{{ $t('project.customer.address') }}</strong></b-col>
    </template>

    <template v-slot:item="slotProps">
      <b-col md="2">{{ slotProps.item.projectnr }}</b-col>
      <b-col md="4">{{ slotProps.item.name }}</b-col>
      <b-col md="4">
        <span class="address1" v-if="customer(slotProps.item.customer).addr1">{{customer(slotProps.item.customer).addr1}}<br/></span>
        <span class="address2" v-if="customer(slotProps.item.customer).addr2">{{customer(slotProps.item.customer).addr2}}<br/></span>
        <span class="address3" v-if="customer(slotProps.item.customer).addr3">{{customer(slotProps.item.customer).addr3}}<br/></span>
        <span class="address4" v-if="customer(slotProps.item.customer).addr4">{{customer(slotProps.item.customer).addr4}}</span>
      </b-col>
    </template>
  </list-view>
</template>

